import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import * as Immutable from 'immutable';

import {
  loadPostsByDiscussionId,
  loadPostsSuccess,
  loadPosts,
  loadCommentsForPostSuccess
} from 'src/app/shared/ui/post/data/store/actions';

import { DiscussionService } from './discussion.service';
import { IPost } from 'src/app/shared/models/post';

@Injectable()
export class DiscussionEffects {
  constructor(private actions$: Actions, private service: DiscussionService) {}

  loadPostsByGroupId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPostsByDiscussionId),
      switchMap((args) =>
        this.service.getPostByDiscussionId(args.id).pipe(
          switchMap((posts) => {
            const commentActions = posts.map((post) => {
              return loadCommentsForPostSuccess({
                post: post,
                comments: post.comments.list,
                isFromPost: true
              });
            });

            return [
              loadPostsSuccess({ posts: this.normalize(posts) }),
              ...commentActions
            ];
          })
        )
      )
    )
  );

  // TODO: refactor
  // duplication of code
  private normalize(items: Array<IPost>) {
    return items.reduce((acc, cur) => {
      return acc.set(cur.id, cur);
    }, Immutable.OrderedMap<number, IPost>());
  }
}
